import { useCallback, useEffect, useState } from "react";

import type { EmblaCarouselType } from "@aviary/components/NewCarousel/emblaCarouselTypes";

type UseAutoplayType = {
  /**
   * Callback for when the arrow button is clicked to stop or reset the autoplay
   */
  onButtonAutoplayClick: (callback: () => void) => void;
  /**
   * Play/pause carousel autoplay
   */
  toggleAutoplay: () => void;
  isPlaying: boolean;
};

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
export const useAutoplay = (emblaApi: EmblaCarouselType): UseAutoplayType => {
  const [isPlaying, setIsPlaying] = useState(false);

  const onButtonAutoplayClick = useCallback(
    (callback: () => void) => {
      const autoplay = emblaApi?.plugins()?.autoplay;
      if (!autoplay) return;

      const stopAutoplay = autoplay.stop;

      stopAutoplay();
      callback();
    },
    [emblaApi]
  );

  const toggleAutoplay = useCallback(() => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const playOrStop = autoplay.isPlaying() ? autoplay.stop : autoplay.play;
    playOrStop();
  }, [emblaApi]);

  useEffect(() => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    setIsPlaying(autoplay.isPlaying());
    emblaApi
      .on("autoplay:play", () => setIsPlaying(true))
      .on("autoplay:stop", () => setIsPlaying(false))
      .on("reInit", () => setIsPlaying(false));
  }, [emblaApi]);

  return {
    onButtonAutoplayClick,
    toggleAutoplay,
    isPlaying,
  };
};
